var React = require('react');

function MinusInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Group_535","data-name":"Group 535","transform":"translate(-830.5 -5253)"},React.createElement("line",{"id":"Line_34","data-name":"Line 34","x2":"20","transform":"translate(830.5 5254.5)","fill":"none","stroke":"#fff","strokeWidth":"3"})));
}

MinusInline.defaultProps = {"width":"20","height":"3","viewBox":"0 0 20 3"};

module.exports = MinusInline;

MinusInline.default = MinusInline;
